export default __webpack_public_path__ + "static/media/redEllipse.22dc6db8.svg";